import classNames from 'classnames';
import React from 'react';

import css from './IconCraftsperson.module.css';

const IconCraftsperson = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
      viewBox="0 0 512 512"
    >
      <path
        d="M349.19 304.33a142.46 142.46 0 0 0-15-12.17 125.16 125.16 0 0 0 42.39-63.53A125.15 125.15 0 0 0 256 69c-69.17 0-125.45 56.27-125.45 125.43a125.8 125.8 0 0 0 4.84 34.19 125.16 125.16 0 0 0 42.42 63.55 142.3 142.3 0 0 0-14.56 11.76c-55.37 51.72-54 127.17-53.9 130.36a9 9 0 0 0 9 8.73h275.31a9 9 0 0 0 9-8.72c.06-3.16 1.47-78.25-53.47-129.97ZM160.42 425.09h-32.8c1.22-17.34 6.86-57.35 32.8-91.34ZM148.51 194.4a107.49 107.49 0 1 1 215 0q0 2.92-.16 5.88l-29.55-50.89a8.93 8.93 0 0 0-9.15-4.36L256 155.79 187.35 145a8.88 8.88 0 0 0-9.15 4.36l-29.53 50.89q-.16-2.92-.16-5.85Zm5.24 32.89 36.89-63.59 64 10a9.25 9.25 0 0 0 2.78 0l64-10 36.89 63.59a107.37 107.37 0 0 1-204.5 0ZM299 312.06v46.84h-85.55v-46.67a122.86 122.86 0 0 0 85.54-.17Zm35.08 113H178.37V314.48A131.4 131.4 0 0 1 193.76 303c.58.34 1.15.69 1.74 1v63.82a9 9 0 0 0 9 9H308a9 9 0 0 0 9-9V303.8c.45-.25.88-.52 1.33-.78a130.21 130.21 0 0 1 15.8 11.81Zm17.95 0v-90.79c25.59 33.89 31.16 73.57 32.36 90.82Z"
        fill="#011602"
      />
    </svg>
  );
};

export default IconCraftsperson;
